module.exports = __webpack_public_path__ + "static/media/bbboltLogo.a923b1f1.png";